<template>
  <div class="d-flex flex-column">
    <p class="mb-0" style="color: var(--v-ThemeText-lighten2);">
      {{ $t('servicesystem.common_objects.lead.state') }}{{ noempty ? '*' : '' }}
    </p>
    <QButtonGroup v-model="internalValue" :list="states" :multiple="multiple" :noempty="noempty" :edit="edit"
      :dense="dense">
    </QButtonGroup>
  </div>


  <!--
    <v-card class="d-flex mb-2" width="fit-content" outlined>
    <LeadStateChip v-for="state in [0, 1, 2]" :key="state" :state="state"
      :disabled="editObject.State != state" @click="editObject.State = state">
    </LeadStateChip>
  </v-card>
  -->
</template>


<script>
//import LeadStateChip from "@/views/admin/leads/LeadsStateChip.vue";

export default {
  name: "LeadStateControl",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    pk: String,
    value: [Number, Array],
    multiple: Boolean,
    dense: Boolean,
    noempty: Boolean,
    edit: Boolean,
  },
  components: {
    //LeadStateChip
  },

  data() {
    return {
      copy: null,
      states: [
        { value: 0, color: "warning", text: this.$t('servicesystem.common_objects.lead.state0') },
        { value: 1, color: "primary", text: this.$t('servicesystem.common_objects.lead.state1') },
        { value: 2, color: "success", text: this.$t('servicesystem.common_objects.lead.state2') },
      ],
    };
  },

  mounted() {
    this.copy = this.value;
  },

  methods: {},

  computed: {
    internalValue: {
      get() {
        return this.copy ?? this.value;
      },
      set(val) {
        this.copy = val;
        this.$emit("change", val);
      },
    },
  },

  watch: {
    value(val) {
      this.copy = val;
    },
  },
};
</script>


<style lang="scss"></style>